/**
 * คลาสร่วมของคอลัมน์ "การดำเนินการ" ที่ต้องตรึงไว้ขอบขวาของตาราง (G3)
 *
 * ที่มา: ตารางหลายหน้ากว้างเกินจอ 1440px ทำให้คอลัมน์ขวาสุดถูกตัด ผู้ใช้ต้องเลื่อนแนวนอน
 * ก่อนจะกดปุ่มได้ · แก้โดยตรึงคอลัมน์ปุ่มไว้ขอบขวาเสมอ ไม่ซ่อนข้อมูลใด ๆ
 *
 * ตารางที่ใช้ `components/ui/Table` ได้ค่านี้อัตโนมัติ (ดู `isStickyColumn` ใน Table.tsx)
 * ส่วนตารางที่เขียน <table> เองให้ import ค่าคงที่นี้ไปใช้ เพื่อให้ทั้งระบบมีนิยามเดียว
 */

/** เงาด้านซ้ายของคอลัมน์ที่ถูกตรึง — บอกผู้ใช้ว่ายังมีเนื้อหาเลื่อนอยู่ข้างใต้ */
export const STICKY_SHADOW = 'shadow-[-4px_0_6px_-1px_rgba(0,0,0,0.06)]';

/** <th> ของคอลัมน์การดำเนินการ */
export const STICKY_ACTION_HEADER = `sticky right-0 z-10 bg-secondary-50 ${STICKY_SHADOW}`;

/**
 * <td> ของคอลัมน์การดำเนินการ แบบยังไม่กำหนดพื้นหลัง
 * ใช้เมื่อแถวมีสีพื้นของตัวเอง (เช่น แถวเกินกำหนด) แล้วต้องส่งคลาส bg-* ของแถวมาเอง
 * — คอลัมน์ที่ตรึงต้องมีพื้นหลังทึบเสมอ ไม่งั้นเนื้อหาที่เลื่อนอยู่ข้างใต้จะทะลุขึ้นมา
 */
export const STICKY_ACTION_CELL_BASE = `sticky right-0 z-10 ${STICKY_SHADOW}`;

/** <td> ของคอลัมน์การดำเนินการ (พื้นหลังทึบ กันแถวข้างใต้เลื่อนทะลุ) */
export const STICKY_ACTION_CELL = `${STICKY_ACTION_CELL_BASE} bg-white group-hover:bg-secondary-50/70`;
